<template>
  <b-row>
    <b-col>
      <left-tabs :tabs="tabs" menu="tipo">
        <template #entry>
          <Entry :stock_items="stock_items" @search="getStockItems" />
        </template>
        <template #transfer>
          <Transfer :stock_items="stock_items" @search="getStockItems" />
        </template>
        <template #output>
          <Output :stock_items="stock_items" @search="getStockItems" />
        </template>
        <template #purchase>
          <Purchase :stock_items="stock_items" @search="getStockItems" />
        </template>
        <template #reversal>
          <Reversal :stock_items="stock_items" @search="getStockItems" />
        </template>
        <template #reversal_purchase>
          <ReversalPurchase
            :stock_items="stock_items"
            @search="getStockItems"
          />
        </template>
      </left-tabs>
    </b-col>
  </b-row>
</template>

<script>
import LeftTabs from "../Components/LeftTabs.vue";

import Entry from "./history/entry";
import Transfer from "./history/transfer";
import Output from "./history/output";
import Purchase from "./history/purchase";
import Reversal from "./history/reversal";
import ReversalPurchase from "./history/reversal-purchase";

import api from "../../services/api";

export default {
  name: "History",

  components: {
    LeftTabs,
    Entry,
    Transfer,
    Output,
    Purchase,
    Reversal,
    ReversalPurchase,
  },

  data() {
    return {
      tabs: [
        { title: "ENTRADA", step: "entry" },
        { title: "TRANSFERÊNCIA", step: "transfer" },
        { title: "SAÍDA", step: "output" },
        { title: "COMPRA", step: "purchase" },
        { title: "ESTORNO", step: "reversal" },
        { title: "ESTORNO DA COMPRA", step: "reversal_purchase" },
      ],
      stock_items: [],
    };
  },

  methods: {
    async getStockItems(search = null) {
      try {
        const params = {
          page: 1,
          itemsPerPage: 25,
          search,
        };

        const response = await api.get("/rest-home/stock/items", { params });

        const { error, errors, stock_items } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.stock_items = stock_items;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>